// src/appRedux/reducers/Chat.js
import {
  SET_SESSION_ADDRESS,
  SET_ROOSTER_LIST,
  SET_COVERSATION_DATA,
  SET_SELECTED_CHAT_USER,
  SET_CHAT_USERS,
  RESET_CHAT_DATA,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  chatId: 1,
  conversationData: [],
  sessionAddress: null,
  rosterList: [],
  selectedUser: null,
  isChatUserListReady: false,
  chatUsers: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_SELECTED_CHAT_USER:
      return { ...state, selectedUser: action.payload };
    case SET_SESSION_ADDRESS:
      return {
        ...state,
        sessionAddress: action.payload,
      };
    case SET_COVERSATION_DATA:
      return { ...state, conversationData: action.payload };
    case SET_ROOSTER_LIST:
      return { ...state, rosterList: action.payload };
    case SET_CHAT_USERS:
      return { ...state, chatUsers: action.payload };
    case RESET_CHAT_DATA:
      return { ...INIT_STATE };
    default:
      return state;
  }
};
